import React from 'react';
import {ComingSoonTooltip} from '../coming-soon/coming-soon.jsx';
import {
    injectIntl,
    FormattedMessage,
    defineMessages
} from 'react-intl';
import ProjectTitleInput from './project-title-input.jsx';
import AuthorInfo from './author-info.jsx';
import './menu-bar.css';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {connect} from 'react-redux';
import SaveButton from './save-button.jsx';
import Button from '../button/button.jsx';
import SB3Uploader from '../containers/sb3-uploader.jsx';
import bindAll from 'lodash.bindall';
import collectMetadata from '../lib/collect-metadata.js';
import { setLoadingModal, setLoginModal } from '../store/modals'
import { setUserLoginState } from '../store/user-state'
import { setMataProjectId, setWriteState, setProjectNamesList } from '../store/project-state'
import uploadBlob from '../lib/upload-blob';
import { postMessageToParent } from '../workbench/iframe-hooks';
import { FileSystem, MAIN_FILE, Statistics, VersionAction } from "../fs/fs";
import LoginModal from '../login/login';
import {message} from 'antd';
import { requestMyProjects } from '../lib/api/work.js';
import { createHost } from "../fs/host";
import { deployment } from "../deployment";
import { fetchMicroPython } from "../micropython/micropython";


const dataURI = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9InJlcGVhdCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDI0IDI0IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAyNDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPgoJLnN0MHtmaWxsOiNDRjhCMTc7fQoJLnN0MXtmaWxsOiNGRkZGRkY7fQo8L3N0eWxlPgo8dGl0bGU+cmVwZWF0PC90aXRsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTIzLjMsMTFjLTAuMywwLjYtMC45LDEtMS41LDFoLTEuNmMtMC4xLDEuMy0wLjUsMi41LTEuMSwzLjZjLTAuOSwxLjctMi4zLDMuMi00LjEsNC4xCgljLTEuNywwLjktMy42LDEuMi01LjUsMC45Yy0xLjgtMC4zLTMuNS0xLjEtNC45LTIuM2MtMC43LTAuNy0wLjctMS45LDAtMi42YzAuNi0wLjYsMS42LTAuNywyLjMtMC4ySDdjMC45LDAuNiwxLjksMC45LDIuOSwwLjkKCXMxLjktMC4zLDIuNy0wLjljMS4xLTAuOCwxLjgtMi4xLDEuOC0zLjVoLTEuNWMtMC45LDAtMS43LTAuNy0xLjctMS43YzAtMC40LDAuMi0wLjksMC41LTEuMmw0LjQtNC40YzAuNy0wLjYsMS43LTAuNiwyLjQsMEwyMyw5LjIKCUMyMy41LDkuNywyMy42LDEwLjQsMjMuMywxMXoiLz4KPHBhdGggY2xhc3M9InN0MSIgZD0iTTIxLjgsMTFoLTIuNmMwLDEuNS0wLjMsMi45LTEsNC4yYy0wLjgsMS42LTIuMSwyLjgtMy43LDMuNmMtMS41LDAuOC0zLjMsMS4xLTQuOSwwLjhjLTEuNi0wLjItMy4yLTEtNC40LTIuMQoJYy0wLjQtMC4zLTAuNC0wLjktMC4xLTEuMmMwLjMtMC40LDAuOS0wLjQsMS4yLTAuMWwwLDBjMSwwLjcsMi4yLDEuMSwzLjQsMS4xczIuMy0wLjMsMy4zLTFjMC45LTAuNiwxLjYtMS41LDItMi42CgljMC4zLTAuOSwwLjQtMS44LDAuMi0yLjhoLTIuNGMtMC40LDAtMC43LTAuMy0wLjctMC43YzAtMC4yLDAuMS0wLjMsMC4yLTAuNGw0LjQtNC40YzAuMy0wLjMsMC43LTAuMywwLjksMEwyMiw5LjgKCWMwLjMsMC4zLDAuNCwwLjYsMC4zLDAuOVMyMiwxMSwyMS44LDExeiIvPgo8L3N2Zz4K'

const MenuBarItemTooltip = ({
    children,
    className,
    enable,
    id,
    place = 'bottom'
}) => {
    if (enable) {
        return <React.Fragment>{children}</React.Fragment>;
    }
    return (
        <ComingSoonTooltip
            className={`comingSoon ${className}`}
            place={place}
            tooltipClassName="comingSoonTooltip"
            tooltipId={id}
        >
            {children}
        </ComingSoonTooltip>
    );
};

MenuBarItemTooltip.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    enable: PropTypes.bool,
    id: PropTypes.string,
    place: PropTypes.oneOf(['top', 'bottom', 'left', 'right'])
};

const messages = defineMessages({
    saved: {
        id: 'gui.meun.saved',
        defaultMessage: 'Successfully saved',
        description: 'Successfully saved'
    },
    savedFailed: {
        id: 'gui.meun.savedFailed',
        defaultMessage: 'Saving error, please check',
        description: 'Saving error, please check'
    },
    projectNameRules: {
        id: 'gui.mywork.projectNameRules',
        defaultMessage: 'Project Name contain 1 to 30 characters',
        description: 'Project Name contain 1 to 30 characters'
    },
    emptyFile: {
        id: 'gui.meun.emptyFile',
        defaultMessage: '文件内容为空，请先编写代码再保存',
        description: 'File is empty, please write code before saving'
    }
})

class WorkMenuItem extends React.Component {
    constructor (
        props
    ) {
        super(props);
        bindAll(this, [
            'saveToServerHandler',
            'toggleSaveButton',
            'handleClickShare',
            // 'modifyButton',
            'handleBindUploadRef',
            'triggerSave',
            'uploadButton',
            'uploadSuccessCallback',
            'checkProjectName',
            'handleLoginDiaClose',
            'handleLoginSuccess',
            'handleMyProjectsRequest'
        ]);
        this.uploadRef = React.createRef();
        this.downloadProjectCallback = null;
        // 请求原生fs等方法接口
        this.logging = deployment.logging;
        this.host = createHost(this.logging);
        this.fs = new FileSystem(this.logging, this.host, fetchMicroPython);
    }
    componentDidMount (){
        // 第一次进入就请求我的全部作品
        if (this.props.loginState && this.props.projectNamesList <= 0) {
            this.handleMyProjectsRequest()
        }
    }
    // 请求我的全部作品
    handleMyProjectsRequest() {
        const queryData = {
            current: 1,
            size: 200,
            type: 6
        }
        let nameList = []
        // 发起接口请求，传递 current 参数用于分页
        new Promise((resolve, reject) => {
            this.setState({loaded: false});
            requestMyProjects(resolve, reject, queryData);
        })
        .then(newData => {
            if (newData.code === 200 && newData.data.records) {
                let newData1 = newData.data.records
                newData1.forEach(item => {
                    // 请求内容并且将文件内容转换为Uint8Array
                    if (item.sourceUrl) {
                        fetch(item.sourceUrl)
                            .then(response => response.arrayBuffer())
                            .then(buffer => {
                                // this.props.onLoadingStarted(false);
                                let name = `${item.title}.py`
                                this.fs.write(
                                    name,
                                    new Uint8Array(buffer),
                                    VersionAction.INCREMENT
                                );
                            })
                            .catch(e => {});
                    }
                    nameList.push(item.title)
                })
            }
            this.props.setProjectNamesList(nameList)
        })
        .catch(error => {
            // 处理错误
            console.error(error);
        });
    }
    // 点击分享
    handleClickShare (waitForUpdate) {
        if (!this.props.isShared) {
            if (this.props.canShare) {
                // save before transitioning to project page
                this.props.onShare();
            }
            if (this.props.canSave) {
                // save before transitioning to project page
                this.props.autoUpdateProject();
                waitForUpdate(true); // queue the transition to project page
            } else {
                waitForUpdate(false); // immediately transition to project page
            }
        }
    }

    uploadSuccessCallback (id) {
        this.props.setMataProjectId(id);
        this.props.onLoadingFinished();
        this.props.onUploadSuccess();
    }


    checkProjectName () {
        const value = this.props.projectTitle && this.props.projectTitle.trim();
        let countLimitCondition = null
        let specialCharacterCondition = null
        if (value) {
            var name = value.replace(/\.py$/, "");
            // 字符数字限制
            countLimitCondition = value.length > 30 || value.length < 1;
            // 限制特殊字符
            specialCharacterCondition = /[`~!@#$%^&*\-+=<>?:"{}|.,\/;'\\[\]·~！@#￥%……&*——\-+={}|《》？：“”【】、；‘’，。、]/.test(name);
        }
        if (!value || countLimitCondition || specialCharacterCondition){
            message.error(this.props.intl.formatMessage(messages.projectNameRules));
            return false;
        }
        return true;
    }

    // 点击保存作品
    async saveToServerHandler (resolve, reject) {
        if (!this.checkProjectName()) return;
        if (!this.props.mataProjectId || (this.props.mataProjectId && this.props.projectTitle !== this.props.projectTitleOld.replace(".py", ""))) {
            const isRepeat = this.props.projectNamesList.some(i => i === this.props.projectTitle)
            if (isRepeat) {
                message.error('该文件名已存在，请重新输入');
                return
            }
        }
        if (this.props.loginState) {
            // 使用老名称的data内容（新名称会搜索不到）
            let projectTitle = this.props.projectTitleOld ? this.props.projectTitleOld : this.props.projectTitle
            this.props.onLoadingStarted(true);
            let data = null
            
            projectTitle = projectTitle.replace(".py", "");
            projectTitle = `${projectTitle}.py`
            data = new Uint8Array(this.props.fs['fs']['fs']['fs']['_files'][projectTitle]['_dataBytes']);
            this.fs.write(
                `${this.props.projectTitle}.py`,
                data,
                VersionAction.INCREMENT
            );
            const blob = new Blob([data], {
                type: "application/octet-stream",
            });
            // const cover = exportBlock(true);
            const rsp = await new Promise((resolve, reject) => {
                uploadBlob(
                    this.props.projectTitle,
                    // cover,
                    dataURI,
                    blob,
                    this.props.mataProjectId ? this.props.mataProjectId : null,
                    resolve,
                    reject
                );
            });
            this.props.onLoadingStarted(false);
            if (rsp) {
                this.props.setMataProjectId(rsp);
                message.success(this.props.intl.formatMessage(messages.saved))
                this.props.onLoadingStarted(false);
                this.props.setWriteState(false)
            } else {
                message.error(this.props.intl.formatMessage(messages.savedFailed));
                this.props.onLoadingStarted(false);
            }
            localStorage.removeItem('projectTitle')
            try {
                if (await this.fs.exists(projectTitle)) {
                    await this.fs.remove(projectTitle);
                }
            } catch (e) {
                // 旧文件不存在时忽略
            }
        } else {
            this.props.onOpenLogin(true);
        }
    }

    toggleSaveButton() {
        let projectTitle = this.props.projectTitleOld ? this.props.projectTitleOld : this.props.projectTitle;
        projectTitle = projectTitle.replace(".py", "");
        const projectFilename = `${projectTitle}.py`;
        const data = new Uint8Array(this.props.fs['fs']['fs']['fs']['_files'][projectFilename]['_dataBytes']);
        // 将 Uint8Array 转换成字符串
        const decoder = new TextDecoder('utf-8');
        let str = decoder.decode(data);
        str = str.replace(/\s+/g, ' ').trim();
        // 工作区为空直接return
        if (!str) {
            message.error(this.props.intl.formatMessage({ id: "project-action-nowork" }));
            return;
        }

        if (this.props.isIframe) {
            const blob = new Blob([data], { type: "application/octet-stream" });
            const pyName = localStorage.getItem('pyName') + '.py' || 'main.py';
            const file = new File([blob], pyName, {
                type: blob.type,
                lastModified: Date.now()
            });

            postMessageToParent('send-works-py', file);
        } else {
            this.saveToServerHandler();
        }
    }

    // 上传：修改名称作品按钮
    uploadButton () {
        return (
            <Button
                ref={this.props.uploadRef}
                className="menuBarButton modifyButton"
                onClick={() => {
                    this.saveToServerHandler(
                        downloadProjectCallback
                    );
                }}
            >
                保存
                {/* <FormattedMessage
                    defaultMessage="Save"
                    description="Label for shared project"
                    id="gui.menuBar.saveWork"
                /> */}
            </Button>
            // <SB3Uploader>
            //     {(className, downloadProjectCallback) => (
            //         <Button
            //             ref={this.props.uploadRef}
            //             className="menuBarButton modifyButton"
            //             onClick={() => {
            //                 this.saveToServerHandler(
            //                     downloadProjectCallback
            //                 );
            //             }}
            //         >
            //             保存
            //         </Button>
            //     )}
            // </SB3Uploader>
        );
    }
    //  保存触发器
    async triggerSave () {
        try {
            this.props.onLoadingStarted(true);
            await new Promise((resolve, reject) => {
                this.uploadRef.downloadProject(resolve, reject);
            });
            this.props.onUploadSuccess();
        } catch (error) {
            this.props.onSaveError(<FormattedMessage
                id="gui.alerts.saveProjectError"
                defaultMessage="Save project error, please try again later"
            />);
            return false;
        } finally {
            this.props.onLoadingFinished();
        }
        return true;
    }

    // 绑定SB3Uploader ref
    handleBindUploadRef (ref) {
        this.uploadRef = ref;
    }
    // 关闭登录弹框
    handleLoginDiaClose() {
        this.props.onOpenLogin(false)
    }
    // 登录成功后
    handleLoginSuccess () {
        this.props.setUserLoginState(localStorage.getItem('token'))
    }

    render () {
        return (
            <div
                style={{display: 'flex', flex: '1'}}
            >
                {this.props.canEditTitle ? (
                    <div
                        className="menuBarItem growable"
                    >
                        <MenuBarItemTooltip
                            enable
                            id="title-field"
                        >
                            <ProjectTitleInput
                                className="titleFieldGrowable"
                                projectTitle={this.props.projectTitle}
                                intl={this.props.intl}
                            />
                        </MenuBarItemTooltip>
                    </div>
                ) : this.props.authorUsername &&
                  this.props.authorUsername !== this.props.username ? (
                      <AuthorInfo
                            className="authorInfo"
                            imageUrl={this.props.authorThumbnailUrl}
                            projectTitle={this.props.projectTitle}
                            userId={this.props.authorId}
                            username={this.props.authorUsername}
                        />
                    ) : null}
                <div className="menuBarItem">
                    {this.props.canShare ? (
                        (this.props.isShowingProject ||
                            this.props.isUpdating) && (
                            <ProjectWatcher
                                onDoneUpdating={this.props.onSeeCommunity}
                            >
                                {waitForUpdate => (
                                    <SaveButton
                                        className="menuBarButton"
                                        isShared={this.props.isShared}
                                        /* eslint-disable react/jsx-no-bind */
                                        onClick={() => {
                                            this.handleClickShare(
                                                waitForUpdate
                                            );
                                        }}
                                        /* eslint-enable react/jsx-no-bind */
                                    />
                                )}
                            </ProjectWatcher>
                        )
                    ) : (
                        <>
                            {/* 上传：新建 */}
                            {/* <SB3Uploader onRef={this.handleBindUploadRef}> */}
                            <SB3Uploader>
                                {(className, downloadProjectCallback) => {
                                    this.downloadProjectCallback = downloadProjectCallback;
                                    return (
                                   
                                        <Button
                                            // ref={this.uploadRef}
                                            className="menuBarButton modifyButton"
                                            onClick={() => {
                                                this.toggleSaveButton();
                                            }}
                                        >
                                            {/* {intl.formatMessage({
                                                id: "meun-item-save-work",
                                            })} */}
                                            <FormattedMessage
                                                id="meun-item-save-work"
                                                defaultMessage="Save"
                                            />
                                            {/* {this.props.title} */}
                                            {/* 保存 */}
                                            {/* {this.props.openLoadingModalState && <div>123</div>} */}
                                            {/* <FormattedMessage
                                                defaultMessage="Save"
                                                description="Label for shared project"
                                                id="gui.menuBar.saveWork"
                                            /> */}
                                        </Button>
                                    );
                                }}
                            </SB3Uploader>
                        </>
                    )}
                    {this.props.canRemix ? remixButton : []}
                </div>
                {this.props.openLoginModalState ? 
                    <LoginModal 
                        onCancel={this.handleLoginDiaClose}
                        onSuccessFunc={this.handleLoginSuccess}
                    /> : null
                }
            </div>
        );
    }
}

WorkMenuItem.propTypes = {
    canEditTitle: PropTypes.bool,
    authorUsername: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    username: PropTypes.string,
    authorThumbnailUrl: PropTypes.string,
    projectTitle: PropTypes.string,
    projectTitleOld: PropTypes.string,
    authorId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onLoadingStarted: PropTypes.func,
    onLoadingFinished: PropTypes.func,
    // onRequestCloseFile: PropTypes.func,
    onUploadSuccess: PropTypes.func,
    onProjectTelemetryEvent: PropTypes.func,

    canShare: PropTypes.bool,
    isShared: PropTypes.bool,
    isShowingProject: PropTypes.bool,
    isUpdating: PropTypes.bool,
    onSeeCommunity: PropTypes.func,
    autoUpdateProject: PropTypes.func,
    loginState: PropTypes.string,
    uploadRef: PropTypes.func,
    // onRef: PropTypes.func,
    setMataProjectId: PropTypes.func,
    onOpenLogin: PropTypes.func,
    onSaveError: PropTypes.func,
    onSetProjectUnchanged: PropTypes.func,
    openLoadingModalState: PropTypes.bool,
    openLoginModalState: PropTypes.bool,
    fs: PropTypes.object,
    isIframe: PropTypes.bool,
};

const mapStateToProps = state => {
    // const user =
    //     state.session && state.session.session && state.session.session.user;
    return {
        mataProjectId: state.projectStore.mataProjectId,
        projectTitle: state.projectStore.title,
        projectTitleOld: state.projectStore.titleOld,
        // username: user ? user.username : null,
        loginState: state.userStore.loginState,
        isIframe: state.userStore.isIframe,
        openLoadingModalState: state.modalsStore.openLoadingModalState,
        openLoginModalState: state.modalsStore.openLoginModalState,
        projectNamesList: state.projectStore.projectNamesList

    };
};

const mapDispatchToProps = dispatch => ({
    // 保存时loading
    onLoadingStarted: (type) => dispatch(setLoadingModal(type)),
//     onRequestCloseFile: () => dispatch(closeFileMenu()),
//     onLoadingFinished: () => dispatch(closeLoadingModal()),
    setMataProjectId: projectId => dispatch(setMataProjectId(projectId)),
//     autoUpdateProject: () => dispatch(autoUpdateProject()),
    onOpenLogin: (type) => dispatch(setLoginModal(type)),
    setUserLoginState: (token) => dispatch(setUserLoginState(token)),
    setWriteState: (type) => dispatch(setWriteState(type)),
    setProjectNamesList: (list) => dispatch(setProjectNamesList(list))
//     onSetProjectUnchanged: () => dispatch(setProjectUnchanged())
});

// export default connect(mapStateToProps, mapDispatchToProps)(WorkMenuItem)
export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(WorkMenuItem);